import { isTextSelection, type Editor } from '@tiptap/core'
import type { EditorState } from '@tiptap/pm/state'
import type { EditorView } from '@tiptap/pm/view'

const TABLE_NODE_NAMES = new Set(['table', 'tableCell', 'tableHeader'])

/** True when any part of the selection range overlaps a table node. */
export function selectionIncludesTable(
  state: EditorState,
  from: number,
  to: number
): boolean {
  let includesTable = false

  state.doc.nodesBetween(from, to, (node) => {
    if (TABLE_NODE_NAMES.has(node.type.name)) {
      includesTable = true
      return false
    }
  })

  return includesTable
}

/** TipTap BubbleMenu visibility for document editor selections. */
export function shouldShowDocumentEditorBubbleMenu({
  editor,
  view,
  state,
  from,
  to,
}: {
  editor: Editor
  view: EditorView
  state: EditorState
  from: number
  to: number
}): boolean {
  const { doc, selection } = state
  const { empty } = selection
  const isEmptyTextBlock =
    !doc.textBetween(from, to).length && isTextSelection(selection)

  if (!view.hasFocus() || empty || isEmptyTextBlock || !editor.isEditable) {
    return false
  }

  return true
}
